<template>
    <el-container style="width:100%">
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree" v-if="treeRangeDisplay">
                    <td-tree
                        :lazyloading="lazyloading"
                        :isDbClick="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :defaultProps="defaultProps"
                        :defaultKey="defaultKey"
                        nodeKey="id"
                        :params="orgTreeInfo"
                        :calInternal="true"
                        :isPaging="true"
                        :interfaceName="interfaceName"
                        ref="TdTree"
                        @onDbClick="onDbClickTree"
                        @onClick="onDbClickTree"
                        :checkNodes="checkNodes"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container style="width:100%">
            <el-header style="height:auto">
                <el-form :inline="true" :model="fromDevice" ref="fromDevice" class="demo-form-inline">
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView" style="display:auto;">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('common.DEVICE_NAME')" prop="sName"> <td-input v-model="fromDevice.sName"></td-input> </el-form-item>
                                    <el-form-item v-show="ipDisplay" :label="$t('common.IP')" prop="ip"> <td-input v-model="fromDevice.ip"></td-input> </el-form-item>
                                    <td-dev-dynamic-query
                                        v-for="(devQueryComponent, index) in devQueryComponents"
                                        v-model="fromDevice[devQueryComponent.keyName]"
                                        :key="index"
                                        :devQueryComponent="devQueryComponent"
                                    ></td-dev-dynamic-query>
                                    <div v-if="itemLength &gt; 4" style="height:0px !important;"><br /></div>
                                    <el-form-item v-show="btnDisabled && treeRangeDisplay && sAllotDisplay" :label="$t('pgCommon.ALLOT_STATUS')" prop="sAllotStatus">
                                        <td-select :options="sAllotStatusList" v-model="fromDevice.sAllotStatus"></td-select>
                                    </el-form-item>
                                    <el-form-item class="paddingLeft10">
                                        <td-button type="primary" :loading="loading" @click="btnClickQuery">{{ $t('common.QUERY') }}</td-button>
                                    </el-form-item>
                                </div>
                            </td-permission>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top:5px;">
                        <el-col :span="24">
                            <el-form-item v-if="addOrDelDisplay || importDisplay || allotDisplay">
                                <td-button type="button" v-show="addOrDelDisplay" :permissions="permissionsAdd" @click="btnAddDevice" :disabled="btnDisabled && treeRangeDisplay">
                                    {{ $t('common.ADD') }}</td-button
                                >
                                <td-button type="button" v-show="addOrDelDisplay" :permissions="permissionsDel" @click="btnDeleteBatch">{{ $t('common.DELETE_BATCH') }}</td-button>
                                <td-button type="button" v-show="importDisplay" :permissions="permissionsImport" @click="btnImportExport">{{ $t('common.IMPORT') }}</td-button>
                                <td-button type="button" v-show="importDisplay" :permissions="permissionsExport" :loading="exportLoadding" @click="btnExport">{{ $t('common.EXPORT') }}</td-button>
                                <td-button type="button" v-show="allotDisplay" :permissions="permissionsAllot" @click="btnAllotBatch">{{ $t('common.ALLOT') }}</td-button>
                                <td-button type="button" v-show="allotDisplay" :permissions="permissionsCancelAllot" @click="btnCancelAllotBatch">{{ $t('common.CANCEL_ALLOT') }}</td-button>
                                <td-button type="button" v-show="sortDisplay" :permissions="permissionsSort" @click="btnSort" :disabled="btnSortDisabled && treeRangeDisplay">{{
                                    $t('pgCommon.SORT_MANAGER')
                                }}</td-button>
                            </el-form-item>
                            <!-- 动态按钮出走处理-->
                            <el-form-item v-for="(button, index) in buttons" :key="index">
                                <!-- 动态按钮处理 -->
                                <template slot-scope="scope">
                                    <my-render v-if="button.render" :row="scope.row" :render="button.render"></my-render>
                                    <!-- <div v-else >
                                {{ scope.row[button.prop] }}
                            </div> -->
                                </template>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main style="margin-top:-10px;">
                <td-permission :permissions="permissionsView" style="width:100%;">
                    <div slot="havePermission">
                        <!-- 加载表格 -->
                        <td-table
                            :columns="columns.length <= 0 ? columnsMyself : columns"
                            :dataSource="tableData"
                            :pageSize="pageSize"
                            :currentPage="currentPage"
                            :total="total"
                            :rowKey="rowKey"
                            :hasLoading="hasLoading"
                            @handleSizeChange="handleSizeChange"
                            @currentChange="currentChange"
                            @selection-change="selectionChange"
                            ref="listdevice"
                        ></td-table>
                    </div>
                </td-permission>
                <!-- 添加设备窗口-->
                <td-addDevice
                    v-if="addDevceAvailable"
                    :isShowDeviceLable="isShowDeviceLable"
                    :title="addTitle"
                    :devDisplay="devDisplay"
                    :nameDisplay="nameDisplay"
                    :ipDisplay="ipDisplay"
                    :ipTypeDisplay="ipTypeDisplay"
                    :portDisplay="portDisplay"
                    :iPSegmentDisplay="iPSegmentDisplay"
                    :descriptionDisplay="descriptionDisplay"
                    :masterServeDisplay="masterServeDisplay"
                    :domainTypeDisplay="domainTypeDisplay"
                    :isOrgDevTree="isOrgDevTree"
                    :isAddData="isAddData"
                    :iDeviceTypes="iDeviceTypes"
                    :orgId="orgId"
                    :orgInfo="orgInfo"
                    :editItem="audioInfo"
                    :defaultPort="defaultPort"
                    :deviceLable="deviceLable"
                    :parentDevLable="parentDevLable"
                    :belongDevDisabled="belongDevDisabled"
                    :portLable="portLable"
                    :extendGroupFlg="extendGroupFlg"
                    :addDevceAvailable="addDevceAvailable"
                    :parentDevType="parentDevType"
                    :devIdReadOnly="devIdReadOnly"
                    ref="addDev"
                    @submit="submit"
                    @setSubmitDevType="setSubmitDevType"
                    @handleExtendDataMethod="handleExtendDataMethod"
                    @handleDataMethod="handleDataMethod"
                    @belongDevChange="belongDevChange"
                    @dlalogClose="dlalogAddClose"
                    :fatherAutoCreateId="fatherAutoCreateId"
                    :isShowAutoId="isShowAutoId"
                    :belongDevRequired="belongDevRequired"
                    :regularCheckID="regularCheckID"
                    :isHandleExtendData="isHandleExtendData"
                    :isHandleData="isHandleData"
                    :isCloseDialog="isCloseDialog"
                    :diySuccessMessage="diySuccessMessage"
                    :addDialogWidth="addDialogWidth"
                    :addDevInfoFormLabelWidth="addDevInfoFormLabelWidth"
                    :beforeSubmitForm="beforeSubmitForm"
                    :treeRangeDisplay="treeRangeDisplay"
                    :belongOrgDisplay="belongOrgDisplay"
                    :isbelongOrgDisplay="isbelongOrgDisplay"
                    :spanNum="spanNum"
                    :nameLable="nameLable"
                    :ipDisabled="ipDisabled"
                    :customNameRegex="customNameRegex"
                    :isEnablePromptInformation="isEnablePromptInformation"
                    :promptCode="promptCode"
                    v-bind="$attrs"
                    v-on="listeners"
                >
                </td-addDevice>
                <!-- 修改设备窗口-->
                <td-modifyDevice
                    v-if="modifyDeviceAvailable"
                    :isShowDeviceLable="isShowDeviceLable"
                    :title="modifyTitle"
                    :isDetailsInfo="isDetailsInfo"
                    :isAddData="isModify"
                    :editableTabs="editableTabs"
                    :devDisplay="devDisplay"
                    :nameDisplay="nameDisplay"
                    :ipDisplay="ipDisplay"
                    :ipTypeDisplay="ipTypeDisplay"
                    :portDisplay="portDisplay"
                    :iPSegmentDisplay="iPSegmentDisplay"
                    :descriptionDisplay="descriptionDisplay"
                    :masterServeDisplay="masterServeDisplay"
                    :domainTypeDisplay="domainTypeDisplay"
                    :isOrgDevTree="isOrgDevTree"
                    :deviceLable="deviceLable"
                    :parentDevLable="parentDevLable"
                    :belongDevDisabled="belongDevDisabled"
                    :isbelongOrgDisplay="isbelongOrgDisplay"
                    :portLable="portLable"
                    :extendGroupFlg="extendGroupFlg"
                    :editItem="editItem"
                    :iDeviceTypes="iDeviceTypes"
                    :parentDevType="parentDevType"
                    :orgInfo="orgInfo"
                    :orgId="orgId"
                    ref="modifyDev"
                    @submit="submit"
                    @setSubmitDevType="setSubmitDevType"
                    @handleExtendDataMethod="handleExtendDataMethod"
                    @handleDataMethod="handleDataMethod"
                    @belongDevChange="belongDevChange"
                    @changePane="changePane"
                    :modifyDeviceAvailable="modifyDeviceAvailable"
                    @dlalogClose="dlalogModifyClose"
                    :fatherAutoCreateId="fatherAutoCreateId"
                    :belongDevRequired="belongDevRequired"
                    :regularCheckID="regularCheckID"
                    :isHandleExtendData="isHandleExtendData"
                    :isHandleData="isHandleData"
                    :isCloseDialog="isCloseDialog"
                    :downloadSettingsTip="downloadSettingsTip"
                    :diySuccessMessage="diySuccessMessage"
                    :devIdReadOnly="devIdReadOnly"
                    :modifyDialogWidth="modifyDialogWidth"
                    :modifyDevInfoFormLabelWidth="modifyDevInfoFormLabelWidth"
                    :beforeSubmitForm="beforeSubmitForm"
                    :spanNum="spanNum"
                    :nameLable="nameLable"
                    :ipDisabled="ipDisabled"
                    :customNameRegex="customNameRegex"
                    :isEnablePromptInformation="isEnablePromptInformation"
                    :promptCode="promptCode"
                    v-bind="$attrs"
                    v-on="$listeners"
                >
                </td-modifyDevice>
                <td-deviceExport
                    :title="title"
                    v-if="isExportVisible"
                    :iDeviceTypes="iDeviceTypes"
                    :orgId="orgId"
                    :isExportVisible="isExportVisible"
                    :isEnablePromptInformation="isEnablePromptInformation"
                    :promptCode="promptCode"
                    @dlalogClose="exportClose"
                    @submit="submit"
                ></td-deviceExport>
                <dialogOrgTree
                    v-if="dlalogOrgTreeVisible"
                    :title="title"
                    :dialogOrgVisible="dlalogOrgTreeVisible"
                    :checkStrictly="true"
                    :checkNodes="dlalogTreeNodes"
                    @orgDialogClose="dlalogTreeClose"
                    @selected="selected"
                    ref="dialogOrgTree"
                ></dialogOrgTree>
                <deviceSort
                    v-if="dialogSortVisible"
                    :title="sortTitle"
                    :dialogSortVisible="dialogSortVisible"
                    :iDeviceTypes="iDeviceTypes"
                    :sOrgId="orgId"
                    @sortDialogClose="dlalogSortClose"
                    ref="dialogSort"
                ></deviceSort>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import dialogOrgTree from './dialogOrgTree.vue';
import deviceSort from './TdDeviceSort.vue';
import resourceApi from '../assets/api.js';
import HashMap from 'hashmap';
export default {
    components: {
        MyRender: {
            functional: true,
            props: {
                row: Object,
                render: Function
            },
            render: (h, ctx) => {
                const params = {
                    row: ctx.props.row,
                    index: ctx.props.index
                };
                if (ctx.props.column) params.column = ctx.props.column;
                return ctx.props.render(h, params);
            }
        },
        dialogOrgTree,
        deviceSort
    },

    /* 接受父组件参数 */
    props: {
        // 设备Id是否显示
        isShowDeviceLable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /*编辑时，表单域标签的宽度设置 */
        modifyDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 110;
            }
        },
        /* 添加时，表单域标签的宽度设置 */
        addDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 110;
            }
        },
        /* 添加dialog宽度设置 */
        addDialogWidth: {
            type: [Number, String],
            default: function() {
                return 800;
            }
        },
        /* 编辑dialog宽度设置 */
        modifyDialogWidth: {
            type: [Number, String],
            default: function() {
                return 800;
            }
        },
        inputs: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //页面操作按钮
        buttons: {
            type: Array,
            default: () => []
        },
        //表头数据
        columns: {
            type: Array,
            default: () => []
        },
        //设备id控件名称
        deviceLable: {
            type: String
        },
        //端口控件名称
        portLable: {
            type: String
        },
        //是否使用默认的添加方法
        isOverWriteAdd: {
            type: Boolean,
            defauit: function() {
                return false;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 所属设备是否显示
        devDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //所属设备是否为组织设备树
        isOrgDevTree: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 名称是否显示
        nameDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //ip类型是否显示
        ipTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // IP是否显示
        ipDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 端口是否显示
        portDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 分配状态是否显示
        sAllotDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 顶级中间件是否显示
        masterServeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 域类型是否显示
        domainTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 描述是否显示
        descriptionDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //弹出窗口标题
        addTitle: {
            type: [String, Number]
        },
        isDetailInfo: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 修改默认tab页面,title：标题，name：控件名称
        editableTabs: {
            type: Array,
            default: function() {
                return [
                    {
                        title: 'common.BASE_INFO',
                        name: 'TdDeviceInfo'
                    },
                    {
                        title: 'common.BELONGED_DEPT',
                        name: 'TdDeviceDept'
                    }
                ];
            }
        },
        //设备添加页面控件名称
        deviceTemplate: {
            type: String,
            default: function() {
                return 'TdDeviceInfo';
            }
        },
        // 父设备类型
        parentDevType: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //所属设备名称
        parentDevLable: {
            type: String,
            default: function() {
                return 'common.BELONGED_DEVICE';
            }
        },
        // 所属设备是否可编辑
        belongDevDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isAddData: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        audioInfo: {
            type: Object,
            default: function() {
                return null;
            }
        },
        //端口默认值
        defaultPort: {
            type: Number,
            default: function() {
                return 3000;
            }
        },
        fatherAutoCreateId: {
            type: Function,
            default: null
        },
        //设备id是否自动生成
        isShowAutoId: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //树形类型，1组织树、2设备树、3组织设备树
        treeType: {
            type: String,
            default: function() {
                return '1';
            }
        },
        // 树形查询设备类型
        deviceTypeList: {
            type: Array,
            default: function() {
                return null;
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        // IP段是否显示
        iPSegmentDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //自定义设备查询组件
        devQueryComponents: {
            type: Array,
            default: () => []
        },
        //所属设备是否必填
        belongDevRequired: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 隐藏的按钮
        hideBtnList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 设备ID是否进行正则校验
        regularCheckID: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //设备ID是否只读
        devIdReadOnly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否处理查询设备数据
        isHandleQueryData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理扩展元素数据
        isHandleExtendData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理表单元素数据
        isHandleData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存后，是否触发关闭dialog方法
        isCloseDialog: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //表单提交前触发的方法
        beforeSubmitForm: Function,
        // 树形区域
        treeRangeDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //是否显示所属组织
        belongOrgDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 所属组织是否禁用
        isbelongOrgDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 分配和取消分配是否显示
        allotDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 排序管理是否显示
        sortDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否是组织树形,默认是
        isOrgTree: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否自定义删除提示信息,默认否
        diyDeviceTip: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否启用删除回调方法
        enableDeleteDeviceCallback: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否提示所属设备已修改，请下传设置
        downloadSettingsTip: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 自定义提示信息
        diySuccessMessage: {
            type: String
        },
        //对话框栅格
        spanNum: {
            type: Number,
            default: function() {
                return 12;
            }
        },
        //label名称
        nameLable: {
            type: String,
            default: function() {
                return 'common.NAME';
            }
        },
        //ip是否可编辑
        ipDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用设备名称自定义校验正则表达式
        customNameRegex: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用回调提示信息自定义等级
        isEnablePromptInformation: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //提示信息内容(状态码，等级)
        promptCode: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    computed: {
        itemLength: function() {
            let ipLength = 0;
            if (this.ipDisplay) {
                ipLength = 1;
            }
            let sAllotStatusLength = 0;
            if (this.btnDisabled && this.treeRangeDisplay && this.sAllotDisplay) {
                sAllotStatusLength = 1;
            }
            let devQueryLength = 0;
            for (var i = 0; i < this.devQueryComponents.length; i++) {
                if (!this.$util.isEmpty(this.devQueryComponents[i].type)) {
                    devQueryLength = parseInt(devQueryLength) + parseInt(1);
                }
            }
            return parseInt(devQueryLength) + parseInt(1) + parseInt(ipLength) + parseInt(sAllotStatusLength);
        }
    },
    created() {
        this.initPermissionStr();
        if (this.hideBtnList.length > 0) {
            for (const hideBtn of this.hideBtnList) {
                switch (Number(hideBtn)) {
                    case 1:
                        this.addOrDelDisplay = false;
                        break;
                    case 2:
                        this.importDisplay = false;
                        break;
                    case 3:
                        this.allotDisplay = false;
                }
            }
        }
        this.interfaceName = { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' };
        this.orgTreeInfo = {
            parentId: '',
            needPage: true,
            pageSize: 50,
            currentPage: 1,
            rootCodes: this.$common.initOrgTreeParam.SCODE,
            orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
            deviceTypeList: this.iDeviceTypes,
            isOrgTree: this.isOrgTree
        };
        //处理设备动态查询组件
        if (this.devQueryComponents.length > 0) {
            for (const componentObj of this.devQueryComponents) {
                this.$set(this.fromDevice, componentObj.keyName, '');
            }
        }
    },
    mounted() {
        this.selfSelect = [];
        if (this.inputs) {
            this.inputs.forEach(val => {
                this.myInPuts.push(val);
            });
        }
        if (!this.treeRangeDisplay) {
            this.btnQuery();
        }
    },
    data() {
        return {
            permissionsView: ['noPermission'],
            permissionsAdd: ['noPermission'],
            permissionsDel: ['noPermission'],
            permissionsEdit: ['noPermission'],
            permissionsImport: ['noPermission'],
            permissionsExport: ['noPermission'],
            permissionsAllot: ['noPermission'],
            permissionsCancelAllot: ['noPermission'],
            permissionsSort: ['noPermission'],
            sAllotStatusList: [{ label: this.$t('pgCommon.ALLOTED'), value: '0' }, { label: this.$t('pgCommon.UNALLOT'), value: '1' }],
            defaultKey: ['21dsec1d-4a27-48d1-we4c5-e44fcc23110'], //展开树形节点数组,默认组织管理根节点
            buttonsEx: [],
            fromDevice: { sName: '', ip: '', sAllotStatus: '' },
            lazyloading: true,
            isClick: true,
            checkNodes: [],
            dlalogTreeNodes: [],
            typeContent: [{ sIcon: 'FIRST_CLASS' }, { sIcon: 'SECOND_CLASS' }],
            editItem: null,
            loading: false,
            addDevceAvailable: false,
            modifyDeviceAvailable: false,
            exportLoadding: false, //导出按钮
            addOrDelDisplay: true, //添加和删除按钮显隐
            importDisplay: true, //导入导出按钮显隐
            calInternal: false,
            showBox: false,
            orgList: [], // 组织
            orgTreeids: [],
            height: 200,
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数,
            isExportVisible: false,
            dlalogOrgTreeVisible: false,
            dialogSortVisible: false,
            orgId: '',
            btnDisabled: true,
            btnSortDisabled: true,
            isModify: false,
            isDetailsInfo: false,
            modifyTitle: this.$t('common.EDIT'),
            fileParam: null,
            orgInfo: null,
            hasLoading: false,
            selfSelect: [],
            systemSet: '21dsec1d-4a27-48d1-we4c5-e44fcc23110',
            interfaceName: {},
            orgTreeInfo: {},
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },

            // 对表单进行数据验证
            myInPuts: [
                {
                    label: 'common.DEVICE_NAME'
                }
            ],
            columnsMyself: [
                // 表头数据
                {
                    prop: 'sName',
                    label: 'common.DEVICE_NAME',
                    align: 'center'
                },

                {
                    prop: 'sIp',
                    label: 'common.IP',
                    align: 'center'
                },
                {
                    prop: 'sParentName',
                    label: 'common.BELONGED_DEVICE',
                    align: 'center'
                },
                {
                    prop: 'sOrgName',
                    label: 'common.BELONGED_DEPT',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let detailBtn = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissionsView },
                                on: {
                                    click: () => {
                                        this.btnDetailInfo(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.DETAIL')
                        );
                        let devEditBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.btnModify(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.EDIT')
                        );
                        let devDeleteBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.deleteDeviceById(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.DELETE')
                        );
                        let devCancelAllotBtn = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.cancelAllot(params.row);
                                    }
                                }
                            },
                            this.$t('common.CANCEL_ALLOT')
                        );
                        let buttonList = [];
                        let isPlayEdit = true;
                        if (!this.$util.isEmpty(params.row.sExtendInfo)) {
                            let nodes = JSON.parse(params.row.sExtendInfo.replace(/\\/g, ''));
                            let privateDomainType = nodes.private_domainType;
                            if (privateDomainType === '1') {
                                isPlayEdit = false;
                            }
                        }
                        if (this.$util.isEmpty(params.row.sDomainType) || params.row.sDomainType === '0') {
                            if (this.$util.isEmpty(params.row.sOrgId)) {
                                if (isPlayEdit) {
                                    buttonList = [devEditBtn, devDeleteBtn];
                                } else {
                                    buttonList = [detailBtn, devDeleteBtn];
                                }
                            } else {
                                if (isPlayEdit) {
                                    buttonList = [devEditBtn, devDeleteBtn, devCancelAllotBtn];
                                } else {
                                    buttonList = [detailBtn, devDeleteBtn, devCancelAllotBtn];
                                }
                            }
                        } else {
                            if (this.$util.isEmpty(params.row.sOrgId)) {
                                buttonList = [detailBtn, devDeleteBtn];
                            } else {
                                buttonList = [detailBtn, devDeleteBtn, devCancelAllotBtn];
                            }
                        }
                        return createElement('div', buttonList);
                    }
                }
            ]
        };
    },
    methods: {
        // 初始化权限字符串
        initPermissionStr() {
            resourceApi.queryDeviceType('', response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/queryDeviceType', response);
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/device/queryDeviceInfo', response.data.statusMessage);
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                let permissionArray = response.data.content;
                let typePermissionMap = new HashMap();
                if (permissionArray.length > 0) {
                    for (let i = 0; i < permissionArray.length; i++) {
                        if (!this.$util.isEmpty(permissionArray[i].iId) && !this.$util.isEmpty(permissionArray[i].sPermissionStr)) {
                            typePermissionMap.set(permissionArray[i].iId, permissionArray[i].sPermissionStr);
                        }
                    }
                }
                let permissionsView = [];
                let permissionsAdd = [];
                let permissionsDel = [];
                let permissionsEdit = [];
                let permissionsImport = [];
                let permissionsExport = [];
                let permissionsAllot = [];
                let permissionsCancelAllot = [];
                let permissionsSort = [];
                for (let i = 0; i < this.iDeviceTypes.length; i++) {
                    let sPermissionStr = typePermissionMap.get(this.iDeviceTypes[i]);
                    let view = sPermissionStr + ':view';
                    permissionsView.push(view);
                    let add = sPermissionStr + ':add';
                    permissionsAdd.push(add);
                    let del = sPermissionStr + ':del';
                    permissionsDel.push(del);
                    let edit = sPermissionStr + ':edit';
                    permissionsEdit.push(edit);
                    let importStr = sPermissionStr + ':import';
                    permissionsImport.push(importStr);
                    let exportStr = sPermissionStr + ':export';
                    permissionsExport.push(exportStr);
                    let allot = sPermissionStr + ':allot';
                    permissionsAllot.push(allot);
                    let cancelAllot = sPermissionStr + ':cancelAllot';
                    permissionsCancelAllot.push(cancelAllot);
                    let sort = sPermissionStr + ':sort';
                    permissionsSort.push(sort);
                }
                this.permissionsView = permissionsView;
                this.permissionsAdd = permissionsAdd;
                this.permissionsDel = permissionsDel;
                this.permissionsEdit = permissionsEdit;
                this.permissionsImport = permissionsImport;
                this.permissionsExport = permissionsExport;
                this.permissionsAllot = permissionsAllot;
                this.permissionsCancelAllot = permissionsCancelAllot;
                this.permissionsSort = permissionsSort;
            });
        },
        rowKey(row) {
            return row.sId + row.sOrgId;
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询
        btnQuery() {
            this.selfSelect = [];
            this.loading = true;
            this.hasLoading = true;
            // let values = this.getInputValues();
            let sParentId = '';
            // 如果是设备
            if (null != this.orgInfo && this.orgInfo.device) {
                sParentId = this.orgInfo.sId;
            }
            let param = {
                sName: this.fromDevice.sName,
                sIp: this.fromDevice.ip,
                sAllotStatus: this.fromDevice.sAllotStatus,
                iDeviceTypes: this.iDeviceTypes,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true,
                sOrgId: this.orgId,
                sParentId: sParentId,
                isDetailInfo: this.isDetailInfo,
                extendInfo: []
            };
            // 不显示树形区域时则设备和组织无关联关系
            if (!this.treeRangeDisplay) {
                param.unLinkOrg = !this.treeRangeDisplay;
            }
            //拼接自定义设备组件查询条件
            if (this.devQueryComponents.length > 0) {
                for (const componentObj of this.devQueryComponents) {
                    //是否根据扩展字段进行查询
                    if (componentObj.hasExtendInfo) {
                        let extendParam = {
                            sElementKey: componentObj.keyName,
                            sElementValue: this.fromDevice[componentObj.keyName],
                            relatively: 0, //查询方式 默认完全匹配
                            operators: 0 //查询条件运算符 默认AND
                        };
                        //查询方式
                        if (componentObj.queryWay) {
                            extendParam.relatively = componentObj.queryWay;
                        }
                        //查询运算符
                        if (componentObj.queryOperators) {
                            extendParam.operators = componentObj.queryOperators;
                        }

                        if (this.$util.isEmpty(extendParam.sElementValue)) {
                            if (!this.$util.isEmpty(componentObj.queryValue)) {
                                if (Number(extendParam.relatively) == 4 || Number(extendParam.relatively) == 8) {
                                    param.extendInfo.push(extendParam);
                                } else {
                                    if (this.$util.isArray(componentObj.queryValue)) {
                                        for (const queryValue of componentObj.queryValue) {
                                            let extendParamNew = this.$util.clone(extendParam);
                                            extendParamNew.sElementValue = queryValue;
                                            param.extendInfo.push(extendParamNew);
                                        }
                                    } else {
                                        extendParam.sElementValue = componentObj.queryValue;
                                        param.extendInfo.push(extendParam);
                                    }
                                }
                            }
                        } else {
                            param.extendInfo.push(extendParam);
                        }
                    } else {
                        if (this.$util.isEmpty(this.fromDevice[componentObj.keyName])) {
                            if (!this.$util.isEmpty(componentObj.queryValue)) {
                                param[componentObj.keyName] = componentObj.queryValue;
                            }
                        } else {
                            param[componentObj.keyName] = this.fromDevice[componentObj.keyName];
                        }
                    }
                }
            }
            //若查询条件中的设备类型存在，清空设备类型数组；原因是后台接口默认设备类型数组查询
            if (!this.$util.isEmpty(param.iDeviceType)) {
                param.iDeviceTypes = [];
            }
            window.pgApi.listDevicePage(JSON.stringify(param), response => {
                this.loading = false;
                this.hasLoading = false;
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/device/queryDeviceInfo', response);

                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceInfo', response.data.statusMessage);

                    return;
                }
                let handleQueryData = response.data.content;
                if (this.isHandleQueryData) {
                    //回掉父组件处理查询数据的方法
                    this.$emit('handleQueryDataMethod', handleQueryData, function(data) {
                        if (data) {
                            handleQueryData = data;
                        }
                    });
                }

                this.tableData = handleQueryData;
                this.total = response.data.count;
                this.$emit('queryOnSuccess', response.data.content);
            });
        },
        // 添加
        btnAddDevice(audio) {
            if (audio === undefined) {
                this.audioInfo = null;
            }
            this.$log.info('btnAddDevice');
            if (!this.isOverWriteAdd) {
                this.$log.info('btnAddDevice myself');
                this.addDevceAvailable = true;
                this.title = this.addTitle; // 标题
            }
            this.$emit('btnAddDevice');
        },
        // 修改
        btnModify(row) {
            this.$log.info('btnModify');
            this.isDetailsInfo = false;
            this.modifyTitle = this.$t('common.EDIT');
            this.editItem = row;
            this.modifyDeviceAvailable = true;
            this.$emit('btnModifyDevice');
        },
        // 详细
        btnDetailInfo(row) {
            this.$log.info('btnDetailInfo');
            this.isDetailsInfo = true;
            this.modifyTitle = this.$t('pgCommon.DETAIL');
            this.editItem = row;
            this.modifyDeviceAvailable = true;
            this.$emit('btnDetailDeviceInfo');
        },
        onDbClickTree(item) {
            this.fromDevice.sAllotStatus = '';
            this.orgInfo = item;
            if (this.treeType === '1') {
                this.orgId = item.id;
            } else {
                this.orgId = this.$util.isEmpty(item.orgId) ? item.sOrgId : item.orgId;
            }
            this.btnClickQuery();
            if ((this.orgId === undefined || this.orgId === '' || this.orgId === this.systemSet || item.noPermission) && this.treeRangeDisplay == true) {
                this.btnDisabled = true;
                this.btnSortDisabled = true;
            } else {
                this.btnDisabled = false;
                this.btnSortDisabled = false;
            }
            this.$emit('event', item);
            this.$nextTick(() => {
                if (this.buttons.length > 0) {
                    this.$refs.listdevice._initTableHeight();
                }
            });
        },

        // 取消分配
        btnCancelAllotBatch() {
            this.$log.info('btnCancelAllotBatch');
            let param = this.getParams();

            if (param.length <= 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('common.DELETE_DEVICE_ORG'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    window.pgApi.deleteMultiDeviceOrg(JSON.stringify(param), response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                            this.$log.error('/device/deleteMultiDeviceOrg', response);
                            return;
                        }
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/device/deleteMultiDeviceOrg', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(e => {
                    this.$log.error('/device/deleteDevice', e);
                });
        },

        // 排序管理
        btnSort() {
            this.sortTitle = this.$t('pgCommon.SORT_MANAGER');
            this.dialogSortVisible = true;
        },

        getSelectData() {
            return this.selfSelect;
        },
        cancelAllot(row) {
            this.$log.info('cancelAllot');
            let orgIds = [];
            if (row) {
                orgIds.push(row.sOrgId);
            }
            let param = {
                sId: row.sId,
                sOrgIdArray: orgIds
            };
            this.deleteDeviceOrg(param);
        },
        // 取消分配
        deleteDeviceOrg(param) {
            this.$confirm(this.$t('common.DELETE_DEVICE_ORG'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    window.pgApi.deleteDeviceOrg(JSON.stringify(param), response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                            this.$log.error('/device/deleteDeviceOrg', response);
                            return;
                        }
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/device/deleteDeviceOrg', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.submit();
                    });
                })
                .catch(e => {
                    this.$log.error('/device/deleteDevice', e);
                    // this.$message.info(this.$t('common.CANCLE_OPERATION'));
                });
        },

        getDeviceDeleteParam() {
            let row = this.selfSelect;
            let paramss = [];
            row.forEach(val => {
                let temp = {
                    sId: val.sId,
                    iDeviceType: val.iDeviceType
                };
                paramss.push(temp);
            });
            return paramss;
        },
        getParams() {
            let row = this.selfSelect;
            let paramss = [];
            row.forEach(val => {
                let temp = {
                    sId: val.sId,
                    sOrgId: val.sOrgId
                };
                paramss.push(temp);
            });
            return paramss;
        },

        refreshDataSource(length) {
            // 刷新数据
            this.tableData.splice(length);
        },
        selectionChange(selection) {
            this.selfSelect = selection;
        },
        // 分配
        btnAllotBatch() {
            // let row = this.$refs.listdevice.getSelectAllRows();
            let row = this.selfSelect;

            if (row.length <= 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });

                return;
            }

            this.dlalogOrgTreeVisible = true;
            this.title = 'common.SELECT_ORG'; // 标题
        },
        // 导出
        btnExport() {
            this.exportLoadding = true;
            let param = new FormData();
            param.append('iDeviceTypes', this.iDeviceTypes);
            param.append('sOrgId', this.orgId);
            param.append('sName', this.fromDevice.sName);
            param.append('sIp', this.fromDevice.ip);
            let responseType = 'arraybuffer';
            resourceApi.exportDevice(param, responseType, response => {
                this.exportLoadding = false;

                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉子解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },
        // 组织树形回调
        selected(node) {
            this.orgTreeids = [];
            let tage = false;
            node.forEach(val => {
                if (val.id === this.systemSet) {
                    tage = true;
                    return;
                }
                this.orgTreeids.push(val.id);
            });
            if (tage) {
                this.$message({ showClose: true, message: this.$t('pgMessage.DEPT_ROOT_NOT_SELECT'), type: 'warning' });
                return;
            }
            // let row = this.$refs.listdevice.getSelectAllRows();
            let row = this.selfSelect;
            let sDeviceId = '';
            for (let i = 0; i < row.length; i++) {
                if (i === 0) {
                    sDeviceId += row[i].sId;
                } else {
                    sDeviceId += ',' + row[i].sId;
                }
            }

            let param = {
                sId: sDeviceId,
                sOrgIdArray: this.orgTreeids
            };

            window.pgApi.addDeviceOrg(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/addDeviceOrg', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.submit();
            });
        },
        // 导入导出打开
        btnImportExport() {
            this.$log.info('btnImportExport');
            this.isExportVisible = true;
            this.title = 'pgCommon.UPLOAD_DEV_EXCEL'; // 标题
        },
        // 设备批量删除
        btnDeleteBatch() {
            this.$log.info('btnDeleteBatch');
            let deleteParam = this.getDeviceDeleteParam();
            if (deleteParam.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE'), type: 'warning' });
                return;
            }
            let param = {
                deviceDeleteVos: deleteParam
            };
            this.deleteDevice(param);
        },
        // 设备删除
        deleteDeviceById(rowObj) {
            let deleteParam = [
                {
                    sId: rowObj.sId,
                    iDeviceType: rowObj.iDeviceType
                }
            ];
            let param = {
                deviceDeleteVos: deleteParam
            };
            this.deleteDevice(param);
        },

        // 删除方法
        deleteDevice(param) {
            if (this.diyDeviceTip) {
                //删除时，回调删除前的方法
                if (this.enableDeleteDeviceCallback) {
                    this.$emit('beforeDeleteDeviceMethod', param, isDelete => {
                        let booleanDelete = Boolean(isDelete);
                        if (booleanDelete) {
                            this.handleDelete(param);
                        }
                    });
                } else {
                    this.handleDelete(param);
                }
            } else {
                this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                    confirmButtonText: this.$t('common.SURE'),
                    cancelButtonText: this.$t('common.CANCEL'),
                    type: 'warning'
                })
                    .then(() => {
                        if (this.enableDeleteDeviceCallback) {
                            this.$emit('beforeDeleteDevice', param, isDelete => {
                                let booleanDelete = Boolean(isDelete);
                                if (booleanDelete) {
                                    this.handleDelete(param);
                                }
                            });
                        } else {
                            this.handleDelete(param);
                        }
                    })
                    .catch(e => {
                        this.$log.error('/device/deleteDevice', e);
                        // this.$message({ showClose: true, message: this.$t('common.UNDELETE'), type: 'info' });
                    });
            }
        },
        handleDelete(param) {
            window.pgApi.deleteDevice(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });

                    this.$log.error('/device/deleteDevice', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/deleteDevice', response.data.statusMessage);
                    return;
                }
                this.submit();
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
            });
        },
        // 获取输入框的值
        getInputValues() {
            let tep = [];
            this.myInPuts.forEach(val => {
                tep.push(val.model);
            });
            return tep;
        },
        // 添加页面关闭
        dlalogAddClose() {
            this.$log.info('dlalogAddClose');
            // 关闭添加窗口
            this.addDevceAvailable = false;
            this.modifyDeviceAvailable = false;
            // this.submit();
            this.audioInfo = null;
        },
        // 修改窗口关闭
        dlalogModifyClose() {
            this.$log.info('dlalogModifyClose');
            this.modifyDeviceAvailable = false;
            this.addDevceAvailable = false;
            // this.submit();
        },
        // 提交之后
        submit() {
            if (this.currentPage === []) {
                this.currentPage = 1;
            }
            this.btnQuery();
            this.$emit('setSubmitSuccess');
        },
        //设置提交保存的设备类型
        setSubmitDevType(submitDevType, callback) {
            this.$emit('setSubmitDevType', submitDevType, function(type) {
                callback(type);
            });
        },
        //保存时是否处理扩展元素数据
        handleExtendDataMethod(extendData, callback) {
            this.$emit('handleExtendDataMethod', extendData, function(data) {
                callback(data);
            });
        },
        //保存时是否处理表单数据
        handleDataMethod(content, callback) {
            this.$emit('handleDataMethod', content, function(data) {
                callback(data);
            });
        },
        // 所属设备change事件
        belongDevChange(value) {
            this.$emit('belongDevChange', value);
        },
        //切换页签
        changePane(pane) {
            this.$emit('changePane', pane);
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 导入导出页面关闭
        exportClose() {
            this.isExportVisible = false;
        },

        // 排序管理页面关闭
        dlalogSortClose() {
            this.dialogSortVisible = false;
        },

        dlalogTreeClose() {
            this.$log.info('dlalogTreeClose');
            this.dlalogOrgTreeVisible = false;
        }
    },
    watch: {}
};
</script>
<style>
.btnStyle {
    margin-left: 20px;
    margin-top: 15px;
}
.audiobtnStyle {
    margin-right: 15px;
    margin-top: 15px;
}
.btnInputStyle {
    margin-left: 10px;
    margin-right: 15px;
}
.inputtyle {
    margin-left: 20px;
    margin-right: 15px;
}
</style>
<style scoped>
/deep/.el-form--inline .el-form-item{
    vertical-align: text-bottom !important;
}
</style>